
import React from "react";
import { CertificateData } from "../Certificates/certificates.types";

/** --------------------- Interfaces----------------------------  */
// Logo Request details
export interface LogoRequestDetails {
    requestId : string,
    requestDetailsData: RequestDetailsData,
    productDescription: DescriptionOfProductData,
    fscClaimLabel :FSCClaimLabelData,
    commentedData: UserCommentedData,
    status: string,
    displayStatus : string,
    requestType : string,
    requestName : string,
    isReadOnly : boolean,
    documentShareFilePath : string,
    agreementShareFilePath : string,
    submittedDate:string,
    customFolderPath:string,
    certificate: CertificateData | null
}

/** Request details data */
export interface RequestDetailsData {
    companyName: string,
    siteName: string[],
    jobName: string,
    fscTrademarkCode: string,
    scsCertificationNumber: string,
    jobNumber: string,
    fscLicenceCode: string,
    labelingAgreementPath : string,
    allSiteMetaData: any[]
}

/** Certificates Sites */
export interface CertificateSite {
    id : string,
    label: string,
    value: string
}

/** Document description data */
export interface DescriptionOfProductData {
  description: string,
}

/** Document description data */
export interface FSCClaimLabelData {
  fscClaimLabel: string,
}

/** User commented data */
export interface UserCommentedData {
 comments: string,
}


// Product type enum
export enum ProductType {
    OnProduct = 1,
    OffProduct = 2
}

// Product type enum string
export enum ProductTypeString {
    OnProduct = 'On Product',
    OffProduct = 'Off Product'
}

/**  Context */
export const RequestMetadaContext = React.createContext<{requestId: string, isReadOnly:boolean, requestType: string, status:string, isMessageEnabled:boolean, isDocumentUploadEnabled:boolean, logoRequestName: string}>({ requestId: '', isReadOnly:false, requestType:'', status:"", isMessageEnabled: false,isDocumentUploadEnabled:false, logoRequestName:""});

/********************** Constants *****************************************/
const LOGO_REQUEST_SUCCESSFULLY_SUBMITTED_MSG = "The logo request has been submitted successfully.";
const LOGO_REQUEST_SUBMITTED_FAIL_MSG = "An error occurred while submitting the logo request.";
const LOGO_REQUEST_CANCEL_SUCCESSFULL_MSG = "The logo request has been cancelled successfully.";
const LOGO_REQUEST_CANCEL_FAIL_MSG = "An error occurred while cancelling the logo request.";

const UNSAVED_CHANGES_CONFRIMATION = "You have unsaved changes. Do you want to save before leaving?";
const LOGO_REQUEST_SUBMIT_CONFIRMATION = "Are you sure you want to submit the logo request?";
const LOGO_REQUEST_CANCEL_CONFIRMATION = "Are you sure you want to cancel the logo request?";
const LOGO_REQUEST_FETCH_FAIL_MSG = "Failed to fetch logo request data.";
const LOGO_REQUEST_CREATE_FAIL_MSG = "Failed to create logo request data.";
const CUSTOMER_SITE_FETCH_FAIL_MSG = "Failed to fetch customer site data.";
const LABELLING_AGREEMENT_MISSING = "The labeling agreement is missing. Kindly upload it."
const SHAREFFILEPATH_UPDATE_FIL_MSG = "An error occurred while updating the path."
const SITE_SELECTION_REQUIRED = "Please select at least one site before submitting."

// Export all constants
export const LogoRequestConstants = {
   LOGO_REQUEST_SUCCESSFULLY_SUBMITTED_MSG,
   LOGO_REQUEST_SUBMITTED_FAIL_MSG,
   LOGO_REQUEST_CANCEL_SUCCESSFULL_MSG,
   LOGO_REQUEST_CANCEL_FAIL_MSG,
   UNSAVED_CHANGES_CONFRIMATION,
   LOGO_REQUEST_SUBMIT_CONFIRMATION,
   LOGO_REQUEST_CANCEL_CONFIRMATION,
   LOGO_REQUEST_FETCH_FAIL_MSG,
   LOGO_REQUEST_CREATE_FAIL_MSG,
   CUSTOMER_SITE_FETCH_FAIL_MSG,
   LABELLING_AGREEMENT_MISSING,
   SHAREFFILEPATH_UPDATE_FIL_MSG,
   SITE_SELECTION_REQUIRED
}